import {
  LOGIN_USER,
  LOGOUT_USER,
  PARENT_LOGIN_USER,
  MENU_ITEMS
} from './auth.types';

export default {
  [LOGIN_USER](state, payload) {
    state.userData = payload;
  },

  [PARENT_LOGIN_USER](state, payload) {
    state.parentSession = payload;
  },

  [MENU_ITEMS](state, payload) {
    state.menuItems = payload;
  },

  [LOGOUT_USER](state) {
    state.parentSession = false;
    state.menuItems = {};
    state.userData = {};
  }
};
